import React, { useContext, useEffect, useState } from 'react';
import { format } from 'date-fns';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Loader, Table } from '@itds/elements/index.js';
import { Colors } from '@itds/Theme';

import NewProduct from './NewProduct';

import { Api } from '@brokerage/utils/Api';

import { AgencyContext } from '@brokerage/contexts/AgencyContext';

const ROUTE_MAPPING = {
  AnnuityQuoter: 'annuity_quoters',
  ApiClient: 'api_clients',
  BgaQuoter: 'bga_quoters',
  FormEngine: 'form_engines',
  LtcQuoter: 'ltc_quoters',
  MobileApp: 'mobile_apps',
  Website: 'websites',
  WebsiteQuoter: 'website_quoters',
  UniversalQuoter: 'universal_quoters'
};

const Products = () => {
  const context = useContext(AgencyContext);
  const navigate = useNavigate();
  const params = useParams();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show_new, toggleNew] = useState(false);

  useEffect(() => {
    Api.loadIxnProducts({ agency_id: params.agency_id, all_products: true }).then(({ data }) => {
      setProducts(data);
      setLoading(false);
    });
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <>
      <NewProduct agency={context.agency} onClose={toggleNew.bind(null, false)} show={show_new} />

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 30 }}>
        <div style={{ marginLeft: 'auto' }}>
          <Button onClick={toggleNew.bind(null, true)}>New Product</Button>
        </div>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            is_sortable: true,
            label: 'Name'
          },
          {
            id: 'type',
            is_sortable: true,
            label: 'Type'
          },
          {
            id: 'is_deactivated',
            is_sortable: true,
            label: 'Active',
            render: product => {
              if (product.is_deactivated) {
                return (
                  <i
                    className='mdi mdi-close-thick'
                    style={{ fontSize: 20, color: Colors.RED.hex }}
                  />
                );
              }

              return (
                <i
                  className='mdi mdi-check-bold'
                  style={{ fontSize: 20, color: Colors.GREEN.hex }}
                />
              );
            },
            styles: { textAlign: 'center' },
            sort_by: product => product.is_deactivated === true
          },
          {
            id: 'created_at',
            label: 'Created Date',
            render: product => format(new Date(product.created_at), 'MMM do, yyyy'),
            styles: { textAlign: 'right' }
          }
        ]}
        data={products}
        defaultSortColumn={{ id: 'is_archived' }}
        onRowClick={product => navigate(`${ROUTE_MAPPING[product.type]}/${product.id}`)}
        placeholder="This agency doesn't have any products yet"
      />
    </>
  );
};

export default Products;
